import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class CommentsAdminService extends BaseService<any> {
  constructor() {
    super(`comments`);
  }
  // Получаем список комментариев
  getComments = async (queryParams: object = {}) => {
    return appAxios.get(`${this.pathWithOrg()}`, { params: queryParams });
  };

  replyToComment = async (commentID: number, data: any) => {
    return appAxios.post(`${this.pathWithOrg()}/${commentID}/reply`, data);
  };

  editComment = async (commentID: number, data: any = {}) => {
    return appAxios.put(`${this.pathWithOrg()}/${commentID}`, data);
  };

  deleteComment = async (commentID: number) => {
    return appAxios.delete(`${this.pathWithOrg()}/${commentID}`);
  };
}

export default new CommentsAdminService();
